export const clientInitialState = {
  isMobileAppUserAgent: false,
};

export interface ClientState {
  isMobileAppUserAgent: boolean;
  isDatadogUserAgent?: boolean;
}
